import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit, deleteDoc
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT, DATA_LIMIT_20} from "../constants/facebook-constant";

export {
    addFacebookAds,
    addSingleFacebookAd,
    updateSingleFacebookAd,
    saveSingleAd,
    deleteSingleFacebookAd,
    getSingleFacebookAd,
    searchFacebookAds,
    searchFacebookAdsWithSearchCriteria,
    prepareFacebookAdsList
}

const collectionName = 'facebook-ads';
const collectionReference = collection(fireStoreDB, collectionName);

const addFacebookAds = (facebookAds) => {
    return Promise.map(facebookAds, async facebookAd => {
        await addSingleFacebookAd(facebookAd);
    });
}

const saveSingleAd = (ad) => {
    const documentReference = doc(fireStoreDB, collectionName, ad.id);

    ad.updatedAt = new Date();
    if (!ad.createdAt) {
        ad.createdAt = ad.updatedAt;
    }

    return setDoc(documentReference, ad, {merge: true});
}

const addSingleFacebookAd = (facebookAd) => {
    facebookAd.createdAt = new Date();
    facebookAd.updatedAt = facebookAd.createdAt;
    return addDoc(collectionReference, facebookAd);
}

const updateSingleFacebookAd = (facebookAd) => {
    const documentReference = doc(fireStoreDB, collectionName, facebookAd.id);
    facebookAd.updatedAt = new Date();
    return setDoc(documentReference, facebookAd);
}

const deleteSingleFacebookAd = (facebookAd) => {
    const documentReference = doc(fireStoreDB, collectionName, facebookAd.id);
    return deleteDoc(documentReference);
}

const getSingleFacebookAd = async (facebookAdId) => {
    const documentReference = doc(fireStoreDB, collectionName, facebookAdId);
    const facebookAdDoc = await getDoc(documentReference);
    return prepareSingleFacebookAd(facebookAdDoc);
}

const searchFacebookAds = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const facebookAdResult = await getDocs(searchQuery);
    return prepareFacebookAdsList(facebookAdResult);
}

const searchFacebookAdsWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchFacebookAdsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }

    searchQuery = query(searchQuery, limit(DATA_LIMIT_20));

    const facebookAdResult = await getDocs(searchQuery);
    return prepareFacebookAdsList(facebookAdResult);
}

const prepareFacebookAdsList = (facebookAdResult) => {
    const facebookAdsList = [];

    _.forEach(facebookAdResult.docs, facebookAdDoc => {
        facebookAdsList.push(prepareSingleFacebookAd(facebookAdDoc));
    });

    return facebookAdsList;
}


const prepareSingleFacebookAd = (facebookAdDoc) => {
    const facebookAd = facebookAdDoc.data();
    facebookAd.id = facebookAdDoc.id;
    return facebookAd;
}
